import { createSlice } from "@reduxjs/toolkit";

export const staffSinglePayslipSlice=createSlice({
    name:'staffSinglePayslipSlice',
    initialState:{
        value:undefined
    },
    reducers:{
        update_single_payslip_list:(state,action)=>{
            state.value=action.payload.singlePayslipData
        }
    }
})

export const{update_single_payslip_list}=staffSinglePayslipSlice.actions
export default staffSinglePayslipSlice.reducer